import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import { Trans } from 'react-i18next';

import { Typography } from '@mui/material';

import { useCreateUrl } from '../../../hooks/useNavigate';

export const OfflineInstitutions = ({ id, description }) => {
  const createUrl = useCreateUrl();

  return (
    <>
      <Typography>
        <Trans i18nKey="We are experiencing some connection instability with {{description}}.">
          We are experiencing some connection instability with
          {' '}
          {{ description }}
          .
        </Trans>
      </Typography>
      <Typography>
        <Trans
          i18nKey="Please check out the last update. We are sorry for the inconvenience."
        >
          Please check out the
          {' '}
          <Link className="dn-ramove-margin" to={createUrl('/links', { institutionId: id })}>
            last update
          </Link>
          . We are sorry for the inconvenience.
        </Trans>
      </Typography>
    </>
  );
};

OfflineInstitutions.propTypes = {
  id: PropTypes.string,
  description: PropTypes.string,
};
